<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="prev-page pr-1 prev">Role Management</span>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">Role Management</h2>
    </div>

    <div class="filter_bar border-top border-bottom border-light mb-4 mb-md-5 mx-n5 px-5">
        <div class="row">

            <div class="col-12 col-md-6 col-lg-3 py-2 py-md-2 px-4 border-right border-light d-flex align-items-center">
                <svg-icon src="./assets/images/icons/box_icon.svg" class="field_icon"></svg-icon>
                <div [autoClose]="'inside'" [ngbPopover]="popContentfilter" triggers="manual" #q="ngbPopover"
                    (click)="openPopoverReceived(q)" (clickOutside)="onClickedOutside($event)" placement="bottom"
                    popoverClass="search_select_popover" class='py-0 px-0 w-100 pl-3'>
                    <!-- <span class="_popover_label">Modules</span> -->
                    <span class="d-flex justify-content-end _popover_arrow">
                        <img src="/assets/images/Path.png" class="padding-left-image pr-3 justify-content-between" />
                    </span>
                    <div class="all">{{selectedModuleFilterName}}</div>
                    <ng-template #popContentfilter>
                        <div class="popover_search">
                            <svg-icon src="/assets/images/icons/search.svg"></svg-icon>
                            <input type="text" placeholder='Search' [(ngModel)]="searchGroup" />
                        </div>
                        <div class="popover_content">
                            <div class="popover_items">
                                <div class="popover_item d-flex align-items-center justify-content-between"
                                    *ngFor="let modulegroup of getFilteredModuleList(); let i=index"
                                    [ngClass]="(selectedModuleFilterName == modulegroup?.moduleName || (modulegroup.moduleName == null && selectedModuleFilterName.length == 0)) && 'active'"
                                    (click)="selectFilterType(modulegroup)">
                                    {{modulegroup?.moduleName}}
                                    <svg-icon src="/assets/images/icons/tick.svg"
                                        *ngIf="selectedModuleFilterName == modulegroup?.moduleName || (modulegroup.moduleName == null && selectedModuleFilterName.length == 0)"></svg-icon>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>

            <!-- <div class="col-12 col-md-6 col-lg-3 py-2 py-md-2 px-4 border-right border-light d-flex align-items-center">
                <svg-icon src="./assets/images/icons/sort_cyan.svg" class="field_icon"></svg-icon>
                <div [autoClose]="'inside'" [ngbPopover]="popContentSort" triggers="manual" #r="ngbPopover"
                    (click)="openPopoverSort(r)" (clickOutside)="onClickedOutside($event)" placement="bottom"
                    popoverClass="search_select_popover" class='py-0 px-0 w-100 pl-3'>
                    <span class="_popover_label">Sort by</span>
                    <span class="d-flex justify-content-end _popover_arrow">
                        <img src="/assets/images/Path.png" class="padding-left-image pr-3 justify-content-between" />
                    </span>
                    <div class="all">{{selectedRoleSortName}}</div>
                    <ng-template #popContentSort>
                        <div class="popover_search">
                            <svg-icon src="/assets/images/icons/search.svg"></svg-icon>
                            <input type="text" placeholder='Search' [(ngModel)]="searchGroupSort" />
                        </div>
                        <div class="popover_content">
                            <div class="popover_items">
                                <div class="popover_item d-flex align-items-center justify-content-between"
                                    *ngFor="let groupsort of mainRoleLatestTypes | filter: searchGroupSort;let i=index"
                                    [ngClass]="multiSelectGroupSort == groupsort?.roleTypeNameSort && 'active'"
                                    (click)="sort('userRoleName',newmainUserRoleList); selectSurveyTypeSort(groupsort);">
                                    {{groupsort?.roleTypeNameSort}}
                                    <svg-icon src="/assets/images/icons/tick.svg"
                                        *ngIf="multiSelectGroupSort == groupsort?.roleTypeNameSort"></svg-icon>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div> -->

            <div class="col-12 col-md-6 col-lg-6 py-2 py-md-2 px-4 d-flex align-items-center">
                <form class="search_form w-100">
                    <svg-icon src="./assets/images/icons/search-box.svg"></svg-icon>
                    <input type="text" name="searchText" id="menu-search" class="search_field"
                        placeholder="Type here to search…" [(ngModel)]="searchText" (keyup)="searchByText(searchText)"
                        (search)="searchByText(searchText)">
                    <button type="submit" class="d-none"></button>
                </form>
            </div>
        </div>
    </div>

    <div class="row row-gap-4">
        <div class="col-12 col-md-6 col-lg-4 col-xl-3" *ngFor="let userrole of newmainUserRoleList | paginate: { itemsPerPage: 50,
            currentPage: page, totalItems:newmainUserRoleList?.length }; let i=index">
            <label
                class="bg-lighter p-3 py-4 rounded d-flex align-items-center column-gap-2 h-100 justify-content-center cursor-pointer rolbox mb-0"
                [for]="userrole.userRolePermissionId + 'list_name'">
                <div class="custom-control custom-radio flex-shrink-0 mt-0 p-0 py-1">
                    <input type="radio" class="custom-control-input" name="list_name"
                        [id]="userrole.userRolePermissionId + 'list_name'" value="{{userrole.userRolePermissionId}}"
                        (change)="isAllSelectedRole(userrole)" value="{{userrole.userRolePermissionId}}"
                        [checked]="roleHasPermission[0]==userrole.userRolePermissionId">
                    <div class="cursor-pointer mb-0">
                        <h3 class="font-weight-bold text-primary h5 mb-0 cursor-pointer">
                            {{userrole.userRoleName}}</h3>
                    </div>
                </div>
                <!-- <div class="w-100 d-flex justify-content-between">
                    <h3 class="font-weight-bold text-primary h5 mb-0 cursor-pointer" [id]="userrole.userRolePermissionId + 'list_name'">
                        {{userrole.userRoleName}}</h3>
                </div> -->
            </label>
        </div>
    </div>

    <div class="cheklist">
        <div class="cheklistul">
            <div class="cheklistli" *ngFor="let permissiontype of newmainRolePermissionList | paginate: { itemsPerPage: 50,
                currentPage: page, totalItems:newmainRolePermissionList?.length }; let i=index">
                <div class="py-2 px-5 d-flex align-items-center column-gap-2 h-100">
                    <div class="custom-control custom-checkbox flex-shrink-0 mt-0">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="permissiontype.isSelected"
                            name="list_name_permission" [id]="permissiontype.permissionTypeId + 'list_name_permission'"
                            value="{{permissiontype.permissionTypeId}}"
                            (change)="isAllSelectedPermission(permissiontype)" [checked]="permissiontype.isSelected"
                            [disabled]="!newDisabledArray.includes(permissiontype.permissionTypeId)">
                        <label [for]="permissiontype.permissionTypeId + 'list_name_permission'"
                            class="custom-control-label cursor-pointer"></label>
                    </div>
                    <div class="w-100 d-flex justify-content-between">
                        <h3 class="mb-0 cursor-pointer"
                            (click)="goToVendorListPage(permissiontype.permissionTypeId, permissiontype.permissionTypeName)">
                            {{permissiontype.permissionTypeName}}</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div
        class="py-3 py-md-4 border-top border-light mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
        <button class="btn btn-primary" type="submit" (click)="submitRolePermission()">Submit</button>
    </div>

    <!-- <div class="d-flex justify-content-center pagination-section mt-4" *ngIf="mainUserRoleList?.length > 10">
        <div class="custom_pagination mt-4 mt-md-5 small">
            <div class="border border-light">
                <pagination-controls class="pagination" (pageChange)="handelReviewList($event)"
                    class="d-flex justify-content-center">
                </pagination-controls>
                <div class="page_numbers">
                    {{indexPage}}/{{paginationCount(mainUserRoleList?.length)}}</div>
            </div>
        </div>
    </div> -->
</div>